import { DefaultApi } from './generated/apis/DefaultApi';

export * from './generated/models';
export * from './generated/runtime';

export class Api extends DefaultApi {}
